const grayscale = {
    name: "grayscale",
    path: "/grayscale",
    title: "grayscale",
    description: "Utilities for applying grayscale filter effects to elements.",
    value: {
        'filter': {
            'grayscale': 'grayscale(100%)',
            'grayscale-<number>': 'grayscale(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "grayscale-50, grayscale-100",
            "description": "to control an element's grayscale:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg grayscale-0",
                        "text": "grayscale-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg grayscale-25",
                        "text": "grayscale-25",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg grayscale-50",
                        "text": "grayscale-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg grayscale",
                        "text": "grayscale",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="grayscale-0" src="/img/mountains.jpg" />
<img class="grayscale-25" src="/img/mountains.jpg" />
<img class="grayscale-50" src="/img/mountains.jpg" />
<img class="grayscale" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default grayscale;